import { createContext, useContext } from 'react';

const StoreContext = createContext({});
export const useStore = (): Record<string, unknown> => useContext(StoreContext);
export const StoreProvider = StoreContext.Provider;
